
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("ls7vK", function(module, exports) {
$parcel$export(module.exports, "useInlineField", () => $c9b292789d0e7188$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFields", () => $c9b292789d0e7188$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useFailedOrTimedOutInlineFields", () => $c9b292789d0e7188$export$31a8c141ddf3a120);

var $gfNVK = parcelRequire("gfNVK");
var $7CE69 = parcelRequire("7CE69");

var $l7E22 = parcelRequire("l7E22");

var $k65BD = parcelRequire("k65BD");
const $c9b292789d0e7188$var$store = (0, $7CE69.createStore)({
    actions: $l7E22.default,
    name: 'forge.custom-fields.inline-fields-state',
    initialState: {}
});
const $c9b292789d0e7188$export$14c9655e9d9e873c = (0, $gfNVK.createHook)($c9b292789d0e7188$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $c9b292789d0e7188$export$71d5b5acb7d7f5ce = (0, $gfNVK.createHook)($c9b292789d0e7188$var$store);
const $c9b292789d0e7188$export$31a8c141ddf3a120 = (0, $gfNVK.createHook)($c9b292789d0e7188$var$store, {
    selector: (state)=>Object.keys(state).filter((fieldId)=>state[fieldId].status === (0, $k65BD.FIELD_STATE_TIMED_OUT) || state[fieldId].status === (0, $k65BD.FIELD_STATE_FAILED))
});

});
parcelRegister("l7E22", function(module, exports) {
$parcel$export(module.exports, "default", () => $75d56ede2aa529b1$export$2e2bcd8739ae039);

var $kSZBj = parcelRequire("kSZBj");
const $75d56ede2aa529b1$var$actions = {
    setFieldState: $kSZBj.setFieldState,
    resetState: $kSZBj.resetState
};
var $75d56ede2aa529b1$export$2e2bcd8739ae039 = $75d56ede2aa529b1$var$actions;

});
parcelRegister("kSZBj", function(module, exports) {
$parcel$export(module.exports, "setFieldState", () => $b28fdee523d51082$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $b28fdee523d51082$export$8e84bad0b35de9e8);

var $k65BD = parcelRequire("k65BD");
const $b28fdee523d51082$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        var _currentState$data$fi, _currentState$data$fi2;
        const currentState = getState();
        const stateObject = {
            status: data.status ?? ((_currentState$data$fi = currentState[data.fieldId]) === null || _currentState$data$fi === void 0 ? void 0 : _currentState$data$fi.status),
            onFormSubmit: data.onFormSubmit ?? ((_currentState$data$fi2 = currentState[data.fieldId]) === null || _currentState$data$fi2 === void 0 ? void 0 : _currentState$data$fi2.onFormSubmit)
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $b28fdee523d51082$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $k65BD.FIELD_STATE_IDLE)
            };
        });
        setState(stateToOverride);
    };

});
parcelRegister("k65BD", function(module, exports) {
$parcel$export(module.exports, "FIELD_STATE_IDLE", () => $58bf05a86180ae1c$export$b764c44e83247012);
$parcel$export(module.exports, "FIELD_STATE_FOCUSED", () => $58bf05a86180ae1c$export$b1fb880ea284915c);
$parcel$export(module.exports, "FIELD_STATE_PENDING", () => $58bf05a86180ae1c$export$aed06c1117bdcc7f);
$parcel$export(module.exports, "FIELD_STATE_STORED", () => $58bf05a86180ae1c$export$83a40b9c32ab4a13);
$parcel$export(module.exports, "FIELD_STATE_FAILED", () => $58bf05a86180ae1c$export$d2a3abef4c91e4ef);
$parcel$export(module.exports, "FIELD_STATE_TIMED_OUT", () => $58bf05a86180ae1c$export$72cc3e6649b0936);
/**
 * Initial field state.
 */ const $58bf05a86180ae1c$export$b764c44e83247012 = 'IDLE';
const $58bf05a86180ae1c$export$b1fb880ea284915c = 'FOCUSED';
const $58bf05a86180ae1c$export$aed06c1117bdcc7f = 'PENDING';
const $58bf05a86180ae1c$export$83a40b9c32ab4a13 = 'STORED';
const $58bf05a86180ae1c$export$d2a3abef4c91e4ef = 'FAILED';
const $58bf05a86180ae1c$export$72cc3e6649b0936 = 'TIMED_OUT';

});




parcelRegister("iCzk3", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldEdit", () => (parcelRequire("8Lepy")).ForgeCustomFieldEdit);

var $8Lepy = parcelRequire("8Lepy");

});
parcelRegister("8Lepy", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldEdit", () => $64d3317729957bcc$export$225b80fdf77ca94e);

var $bSJIT = parcelRequire("bSJIT");

var $gYq50 = parcelRequire("gYq50");

var $fKuli = parcelRequire("fKuli");

var $7UzY5 = parcelRequire("7UzY5");

var $5TkOb = parcelRequire("5TkOb");
parcelRequire("8rEUQ");
var $aQo30 = parcelRequire("aQo30");
parcelRequire("f0N3Z");
var $1iTUu = parcelRequire("1iTUu");
const $64d3317729957bcc$export$225b80fdf77ca94e = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, loadingComponent: loadingComponent, onSubmit: onSubmit, analyticsAttributes: analyticsAttributes })=>{
    const containerRef = (0, $bSJIT.useRef)(null);
    const { submit: submit } = (0, $aQo30.useForgeCustomFieldStateSync)({
        analyticsAttributes: analyticsAttributes,
        onSubmit: onSubmit,
        containerRef: containerRef,
        fieldId: extensionData.fieldId
    });
    const getComponents = (0, $bSJIT.useCallback)((defaults)=>({
            ...defaults,
            CustomFieldEdit: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1iTUu.CustomFieldEdit), {
                    ...props,
                    fieldId: extensionData.fieldId
                })
        }), [
        extensionData.fieldId
    ]);
    const bridge = (0, $bSJIT.useMemo)(()=>({
            // The typing of the submit method is not correct in the Forge UI types.
            // It works with promises, but it is not reflected in there.
            submit: submit
        }), [
        submit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fKuli.ExtensionPointProvider), {
        extensionType: extension.type,
        noWrapper: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7UzY5.ExtensionProvider), {
        extension: extension,
        noWrapper: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5TkOb.Renderer), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        getComponents: getComponents,
        entryPoint: "edit",
        bridge: bridge,
        loadingComponent: loadingComponent,
        contextTokenType: (0, $gYq50.ContextTokenType).JIRA
    }))));
};

});
parcelRegister("8rEUQ", function(module, exports) {
$parcel$export(module.exports, "useForgeCustomFieldStateSync", () => (parcelRequire("aQo30")).useForgeCustomFieldStateSync);

var $aQo30 = parcelRequire("aQo30");

});
parcelRegister("aQo30", function(module, exports) {
$parcel$export(module.exports, "useForgeCustomFieldStateSync", () => $35b9388e837557a1$export$874dabc3a2adff36);
/* oxlint-disable no-void */ 
var $bSJIT = parcelRequire("bSJIT");
parcelRequire("ljwNr");
var $kUOXt = parcelRequire("kUOXt");

var $ls7vK = parcelRequire("ls7vK");

var $k65BD = parcelRequire("k65BD");

var $k9GU2 = parcelRequire("k9GU2");
const $35b9388e837557a1$export$874dabc3a2adff36 = ({ fieldId: fieldId, containerRef: containerRef, onSubmit: onSubmit, analyticsAttributes: analyticsAttributes })=>{
    const [fieldState, { setFieldState: setFieldState }] = (0, $ls7vK.useInlineField)(fieldId);
    const fieldStateRef = (0, $bSJIT.useRef)(fieldState);
    const recentSubmitIdRef = (0, $bSJIT.useRef)(Symbol('submit-id'));
    const isInFocus = (0, $bSJIT.useCallback)(()=>{
        var _containerRef$current;
        return(// Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        containerRef.current === document.activeElement || ((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.contains(document.activeElement)));
    }, [
        containerRef
    ]);
    const syncFieldFocusState = (0, $bSJIT.useCallback)(()=>{
        var _fieldStateRef$curren;
        if (isInFocus()) setFieldState({
            fieldId: fieldId,
            status: (0, $k65BD.FIELD_STATE_FOCUSED)
        });
        else if (((_fieldStateRef$curren = fieldStateRef.current) === null || _fieldStateRef$curren === void 0 ? void 0 : _fieldStateRef$curren.status) === (0, $k65BD.FIELD_STATE_FOCUSED)) setFieldState({
            fieldId: fieldId,
            status: (0, $k65BD.FIELD_STATE_PENDING)
        });
    }, [
        isInFocus,
        setFieldState,
        fieldId
    ]);
    /**
   * This function is called when the form is submitted.
   * It is used to sync the actual state of the field with our internal storage.
   * This is necessary because the Forge fields defined using Custom UI are rendered in the iframe and not all their focus/blur events are propagated to the parent.
   * We also want to manually trigger the blur event on the field so attached blur handlers kick in and the field's value gets submitted.
   */ const onFormSubmit = (0, $bSJIT.useCallback)(()=>{
        syncFieldFocusState();
        if (isInFocus()) {
            var _document$activeEleme, _document$activeEleme2;
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || (_document$activeEleme2 = _document$activeEleme.blur) === null || _document$activeEleme2 === void 0 || _document$activeEleme2.call(_document$activeEleme);
        }
    }, [
        syncFieldFocusState,
        isInFocus
    ]);
    (0, $bSJIT.useEffect)(()=>{
        setFieldState({
            onFormSubmit: onFormSubmit,
            fieldId: fieldId,
            status: (0, $k65BD.FIELD_STATE_IDLE)
        });
    }, // Keep these dependencies immutable, otherwise we are going to override the field's state.
    [
        fieldId,
        onFormSubmit,
        setFieldState
    ]);
    (0, $bSJIT.useEffect)(()=>{
        fieldStateRef.current = fieldState;
    }, [
        fieldState,
        setFieldState
    ]);
    (0, $bSJIT.useEffect)(()=>{
        syncFieldFocusState();
        // Wait for the focus to be moved to the element.
        // In case of iframes it is not immediate so we must use a slight delay.
        const delayedFieldFocusStateSync = ()=>setTimeout(syncFieldFocusState, 100);
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.addEventListener('focusout', delayedFieldFocusStateSync);
        return ()=>{
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            document.removeEventListener('focusout', delayedFieldFocusStateSync);
        };
    }, [
        syncFieldFocusState,
        fieldId
    ]);
    /**
   * Submit bridge method implementation.
   * It is possible for the app to programmatically submit the field multiple times.
   * And it may be the case that they submit a promise that takes time to resolve.
   * Because of that we need to update the state when the last pending submit is resolved.
   */ const analyticsAttributesRef = (0, $kUOXt.default)(analyticsAttributes);
    const submit = (0, $bSJIT.useCallback)(async ({ data: data })=>{
        recentSubmitIdRef.current = Symbol('submit-id');
        const scopedSubmitId = recentSubmitIdRef.current;
        await setFieldState({
            fieldId: fieldId,
            status: (0, $k65BD.FIELD_STATE_PENDING)
        });
        try {
            const resolvedValue = await Promise.resolve(data);
            if (scopedSubmitId === recentSubmitIdRef.current) {
                onSubmit(resolvedValue);
                await setFieldState({
                    fieldId: fieldId,
                    status: (0, $k65BD.FIELD_STATE_STORED)
                });
                const { source: source, renderContext: renderContext, experience: experience } = analyticsAttributesRef.current;
                await (0, $k9GU2.fireTrackEditedEvent)(source, {
                    renderContext: renderContext,
                    experience: experience
                });
            }
        } catch (error) {
            await setFieldState({
                fieldId: fieldId,
                status: (0, $k65BD.FIELD_STATE_FAILED)
            });
            const { source: source, renderContext: renderContext, experience: experience } = analyticsAttributesRef.current;
            await (0, $k9GU2.fireOperationalEditFailedEvent)(source, {
                renderContext: renderContext,
                experience: experience,
                error: error
            });
        }
        return undefined;
    }, [
        fieldId,
        setFieldState,
        onSubmit,
        analyticsAttributesRef
    ]);
    return (0, $bSJIT.useMemo)(()=>({
            submit: submit
        }), [
        submit
    ]);
};

});
parcelRegister("ljwNr", function(module, exports) {
$parcel$export(module.exports, "useLatestRef", () => (parcelRequire("kUOXt")).default);

var $kUOXt = parcelRequire("kUOXt");

});
parcelRegister("kUOXt", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0cf02da82768f2a$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
/**
 * Returns a ref that always holds the latest value of the given argument.
 */ const $a0cf02da82768f2a$var$useLatestRef = (value)=>{
    const ref = (0, $bSJIT.useRef)(value);
    // Synchronous assignment ensures ref.current is always up-to-date
    ref.current = value;
    return ref;
};
var $a0cf02da82768f2a$export$2e2bcd8739ae039 = $a0cf02da82768f2a$var$useLatestRef;

});


parcelRegister("k9GU2", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $9f0798a03bd16770$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireTrackEditedEvent", () => $9f0798a03bd16770$export$1798d320c6527c08);

var $i7phc = parcelRequire("i7phc");

var $jGRkm = parcelRequire("jGRkm");

var $kMn38 = parcelRequire("kMn38");

var $hOiPj = parcelRequire("hOiPj");
const $9f0798a03bd16770$export$762dee9e981de3e1 = (source, attributes)=>(0, $jGRkm.fireOperationalEvent)((0, $kMn38.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        attributes: attributes,
        source: source,
        id: (0, $hOiPj.getEventId)({
            module: (0, $i7phc.CUSTOM_FIELD),
            moduleType: (0, $kMn38.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $i7phc.ENTRY_POINT_EDIT)
        })
    });
const $9f0798a03bd16770$export$1798d320c6527c08 = (source, attributes)=>(0, $jGRkm.fireTrackEvent)((0, $kMn38.TRACK_ACTIONS).EDITED, {
        attributes: attributes,
        source: source,
        id: (0, $hOiPj.getEventId)({
            module: (0, $i7phc.CUSTOM_FIELD),
            moduleType: (0, $kMn38.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $i7phc.ENTRY_POINT_EDIT)
        })
    });

});
parcelRegister("jGRkm", function(module, exports) {
$parcel$export(module.exports, "createAttributes", () => $fd8e1e244e2ddce7$export$c7c9603a6b1fd815);
$parcel$export(module.exports, "fireOperationalEvent", () => $fd8e1e244e2ddce7$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireScreenEvent", () => $fd8e1e244e2ddce7$export$59608e0169622110);
$parcel$export(module.exports, "fireTrackEvent", () => $fd8e1e244e2ddce7$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireInitializationEvent", () => $fd8e1e244e2ddce7$export$390a62413962e4f0);

var $j3LDE = parcelRequire("j3LDE");

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");

var $iRD29 = parcelRequire("iRD29");

var $kMn38 = parcelRequire("kMn38");

var $hOiPj = parcelRequire("hOiPj");
const $fd8e1e244e2ddce7$export$78c6267359db7e73 = (error)=>({
        ...error,
        stack: error.stack,
        message: error === null || error === void 0 ? void 0 : error.message
    });
const $fd8e1e244e2ddce7$export$947749d756ccb0a = ()=>(0, $fuVmc.getMeta)('ajs-is-synthetic') === 'true';
const $fd8e1e244e2ddce7$export$1d1321d2b374d697 = ()=>{
    var _window;
    const re = /^(local|PFE-BB-.*)$/;
    const buildKey = typeof window !== 'undefined' ? (_window = window) === null || _window === void 0 ? void 0 : _window.BUILD_KEY : globalThis === null || globalThis === void 0 ? void 0 : globalThis.BUILD_KEY;
    return buildKey ? re.test(buildKey) : false;
};
const $fd8e1e244e2ddce7$export$c7c9603a6b1fd815 = (rawAttributes)=>{
    const attributes = {
        isSynthetic: $fd8e1e244e2ddce7$export$947749d756ccb0a(),
        ...(0, $lFpPv.isOverridingFragmentsAnalyticsPropEnabled)() && {
            isOverridingFragments: $fd8e1e244e2ddce7$export$1d1321d2b374d697()
        },
        isSSR: false,
        shard: (0, $fuVmc.getMeta)('ajs-shard') || '',
        region: (0, $fuVmc.getMeta)('ajs-region') || ''
    };
    if (rawAttributes) {
        const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
        if (source) attributes.source = source;
        if (error) {
            attributes.error = $fd8e1e244e2ddce7$export$78c6267359db7e73(error);
            attributes.errorType = (0, $hOiPj.getErrorType)(error);
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($j3LDE)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
    }
    return {
        ...rawAttributes,
        ...attributes
    };
};
const $fd8e1e244e2ddce7$var$createAnalyticsProps = ({ id: id, action: action, attributes: attributes, source: source })=>({
        source: source,
        action: action,
        actionSubject: `${0, $kMn38.PACKAGE_NAME_GASV3}.${id}`,
        attributes: $fd8e1e244e2ddce7$export$c7c9603a6b1fd815(attributes)
    });
const $fd8e1e244e2ddce7$var$createScreenAnalyticsProps = ({ id: id, attributes: attributes, source: source })=>({
        source: source,
        name: `${0, $kMn38.PACKAGE_NAME_GASV3}.${id}`,
        attributes: $fd8e1e244e2ddce7$export$c7c9603a6b1fd815(attributes)
    });
const $fd8e1e244e2ddce7$var$getAnalyticsClient = async ()=>(await (0, $iRD29.getAnalyticsWebClientPromise)()).getInstance();
const $fd8e1e244e2ddce7$var$sendOperationalEvent = async (props)=>(await $fd8e1e244e2ddce7$var$getAnalyticsClient()).sendOperationalEvent($fd8e1e244e2ddce7$var$createAnalyticsProps(props));
const $fd8e1e244e2ddce7$var$sendScreenEvent = async (props)=>(await $fd8e1e244e2ddce7$var$getAnalyticsClient()).sendScreenEvent($fd8e1e244e2ddce7$var$createScreenAnalyticsProps(props));
const $fd8e1e244e2ddce7$var$sendTrackEvent = async (props)=>(await $fd8e1e244e2ddce7$var$getAnalyticsClient()).sendTrackEvent($fd8e1e244e2ddce7$var$createAnalyticsProps(props));
const $fd8e1e244e2ddce7$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$fd8e1e244e2ddce7$var$sendOperationalEvent({
        ...eventProps,
        source: source,
        action: action
    });
const $fd8e1e244e2ddce7$export$59608e0169622110 = async (props)=>$fd8e1e244e2ddce7$var$sendScreenEvent(props);
const $fd8e1e244e2ddce7$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$fd8e1e244e2ddce7$var$sendTrackEvent({
        action: action,
        source: source,
        ...eventProps
    });
const $fd8e1e244e2ddce7$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>{
    await $fd8e1e244e2ddce7$export$a1fb57756f0de62b(action, {
        id: id,
        attributes: attributes,
        source: source
    });
};

});
parcelRegister("kMn38", function(module, exports) {
$parcel$export(module.exports, "INITIALIZATION_ACTIONS", () => $69de785809f74cc2$export$ee3931e2f9697d12);
$parcel$export(module.exports, "OPERATIONAL_ACTIONS", () => $69de785809f74cc2$export$42bcca5cae2ce90b);
$parcel$export(module.exports, "TRACK_ACTIONS", () => $69de785809f74cc2$export$2af0438304d7c4b2);
$parcel$export(module.exports, "SOURCES", () => $69de785809f74cc2$export$943fbf5772aef446);
$parcel$export(module.exports, "RENDER_CONTEXTS", () => $69de785809f74cc2$export$3c472a6a5a142ba3);
$parcel$export(module.exports, "EXPERIENCES", () => $69de785809f74cc2$export$a2008ed3b02411a3);
$parcel$export(module.exports, "FORGE_SAMPLING_RATE", () => $69de785809f74cc2$export$d920cee73ec094d0);
$parcel$export(module.exports, "DEBOUNCE_INTERVAL", () => $69de785809f74cc2$export$e39301eefbc90236);
$parcel$export(module.exports, "PACKAGE_NAME_GASV3", () => $69de785809f74cc2$export$f892f621fb508154);
$parcel$export(module.exports, "MODULE_TYPE_EXTENSION", () => $69de785809f74cc2$export$725bacc669333eef);
$parcel$export(module.exports, "KNOWN_NETWORK_ERRORS", () => $69de785809f74cc2$export$c748438cec453c9f);
$parcel$export(module.exports, "KNOWN_NETWORK_ERRORS_TYPES", () => $69de785809f74cc2$export$3876cb851aa46193);
$parcel$export(module.exports, "commonErrors", () => $69de785809f74cc2$export$849ddf4840364232);
$parcel$export(module.exports, "userConsentErrorRegex", () => $69de785809f74cc2$export$dddade71b333c01d);
const $69de785809f74cc2$export$ee3931e2f9697d12 = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $69de785809f74cc2$export$42bcca5cae2ce90b = {
    FAILED: 'failed',
    EDIT_FAILED: 'edit failed'
};
const $69de785809f74cc2$export$2af0438304d7c4b2 = {
    EDITED: 'edited'
};
const $69de785809f74cc2$export$943fbf5772aef446 = {
    PORTAL_REQUEST: 'portal-request',
    PORTAL_VIEW: 'portal-view',
    UNKNOWN_SOURCE: 'unknownSource',
    CSM_CONTACT_FORM: 'csm-contact-form'
};
const $69de785809f74cc2$export$3c472a6a5a142ba3 = {
    PORTAL_REQUEST: 'portal-request',
    PORTAL_VIEW: 'portal-view',
    CSM_CONTACT_FORM: 'csm-contact-form'
};
const $69de785809f74cc2$export$a2008ed3b02411a3 = {
    PORTAL_REQUEST: 'portal-request',
    PORTAL_VIEW: 'portal-view',
    CSM_CONTACT_FORM: 'csm-contact-form'
};
const $69de785809f74cc2$export$d920cee73ec094d0 = 10; // every 10th event is sent
const $69de785809f74cc2$export$e39301eefbc90236 = 10; // 10 ms
const $69de785809f74cc2$export$f892f621fb508154 = 'jiraForgeUi';
const $69de785809f74cc2$export$725bacc669333eef = 'extension';
const $69de785809f74cc2$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $69de785809f74cc2$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $69de785809f74cc2$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $69de785809f74cc2$export$849ddf4840364232 = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $69de785809f74cc2$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');

});

parcelRegister("hOiPj", function(module, exports) {
$parcel$export(module.exports, "getErrorType", () => $5d5f84838cc7250d$export$e19f9f08a6d79fd2);
$parcel$export(module.exports, "getEventId", () => $5d5f84838cc7250d$export$5639f6a927500d9);

var $i7phc = parcelRequire("i7phc");

var $kMn38 = parcelRequire("kMn38");
const $5d5f84838cc7250d$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    if (rateLimitingRegex.test(message)) return 'RATE_LIMITING';
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = (match === null || match === void 0 ? void 0 : match[1]) ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return 'DATA_CLASSIFICATION_NO_ACCESS';
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ((0, $kMn38.userConsentErrorRegex).test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return 'AGG_UNDERLYING_SERVICE_TIMEOUT';
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp('Invoke value functions failed:', 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === 400;
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === 408;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return 'RATE_LIMITING';
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($5d5f84838cc7250d$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    const entry = Object.entries((0, $kMn38.commonErrors)).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ($5d5f84838cc7250d$export$2e7adc44463c3f4f(error)) return 'FAILED_TO_FETCH';
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};
const $5d5f84838cc7250d$export$2e7adc44463c3f4f = (error)=>{
    if (!error || typeof error !== 'object') return false;
    const err = error;
    return (0, $kMn38.KNOWN_NETWORK_ERRORS_TYPES).includes(err.name) || $5d5f84838cc7250d$var$isClientFetchErrorMessage(err.message) || typeof err.cause === 'object' && ((0, $kMn38.KNOWN_NETWORK_ERRORS_TYPES).includes(err.cause.name) || $5d5f84838cc7250d$var$isClientFetchErrorMessage(err.cause.message));
};
const $5d5f84838cc7250d$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_CHUNK_LOAD_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isChunkLoadErrorMessage = (message)=>Boolean(message) && !!KNOWN_CHUNK_LOAD_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isChunkLoadErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isChunkLoadErrorMessage(String(error.cause.message)));
};
const $5d5f84838cc7250d$var$isClientFetchErrorMessage = (message)=>Boolean(message) && (0, $kMn38.KNOWN_NETWORK_ERRORS).some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $5d5f84838cc7250d$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $5d5f84838cc7250d$var$prepareModuleMode = (entryPoint)=>`${$5d5f84838cc7250d$var$capitalizeFirstLetter(entryPoint)}`;
const $5d5f84838cc7250d$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $5d5f84838cc7250d$export$b7ac61bfac7e8766 = (moduleName)=>(0, $i7phc.JIRA_MODULES).includes(moduleName) ? $5d5f84838cc7250d$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $5d5f84838cc7250d$export$5639f6a927500d9 = ({ entryPoint: entryPoint, module: module, moduleType: moduleType = (0, $kMn38.MODULE_TYPE_EXTENSION) })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return `${$5d5f84838cc7250d$export$b7ac61bfac7e8766(module)}${eventNamePostfix}`;
    return `${$5d5f84838cc7250d$export$b7ac61bfac7e8766(module)}${$5d5f84838cc7250d$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`;
};

});





parcelRegister("f0N3Z", function(module, exports) {
$parcel$export(module.exports, "CustomFieldEdit", () => (parcelRequire("1iTUu")).CustomFieldEdit);

var $1iTUu = parcelRequire("1iTUu");

});
parcelRegister("1iTUu", function(module, exports) {
$parcel$export(module.exports, "CustomFieldEdit", () => $355ff1a29ce2794d$export$5de2ecfed36387cf);
/* oxlint-disable no-void */ 
var $bSJIT = parcelRequire("bSJIT");

var $ls7vK = parcelRequire("ls7vK");

var $k65BD = parcelRequire("k65BD");
const $355ff1a29ce2794d$export$5de2ecfed36387cf = ({ forgeDoc: forgeDoc, render: render, fieldId: fieldId })=>{
    const [fieldState, { setFieldState: setFieldState }] = (0, $ls7vK.useInlineField)(fieldId);
    const containerRef = (0, $bSJIT.useRef)(null);
    const isBlurEventTriggeredOutsideTheField = (0, $bSJIT.useCallback)((e)=>{
        var _containerRef$current;
        return (fieldState === null || fieldState === void 0 ? void 0 : fieldState.status) === (0, $k65BD.FIELD_STATE_FOCUSED) && !((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.relatedTarget));
    }, [
        fieldState
    ]);
    const submitOnBlur = (0, $bSJIT.useCallback)((e)=>{
        const { disableSubmitOnBlur: disableSubmitOnBlur, onSubmit: onSubmit } = forgeDoc.props || {};
        if (disableSubmitOnBlur) return;
        try {
            const shouldSubmit = isBlurEventTriggeredOutsideTheField(e);
            setFieldState({
                fieldId: fieldId,
                status: (0, $k65BD.FIELD_STATE_PENDING)
            });
            if (shouldSubmit && typeof onSubmit === 'function') onSubmit();
        } catch (error) {
            setFieldState({
                fieldId: fieldId,
                status: (0, $k65BD.FIELD_STATE_FAILED)
            });
        }
    }, [
        fieldId,
        forgeDoc.props,
        isBlurEventTriggeredOutsideTheField,
        setFieldState
    ]);
    const handleFocus = (0, $bSJIT.useCallback)(()=>{
        setFieldState({
            fieldId: fieldId,
            status: (0, $k65BD.FIELD_STATE_FOCUSED)
        });
    }, [
        fieldId,
        setFieldState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($355ff1a29ce2794d$var$InteractiveComponent, {
        ref: containerRef,
        onBlur: submitOnBlur,
        onFocus: handleFocus
    }, forgeDoc.children.map(render));
};
const $355ff1a29ce2794d$var$InteractiveComponent = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, ...restProps }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        tabIndex: -1,
        role: "group",
        ref: ref,
        ...restProps
    }, children);
});
$355ff1a29ce2794d$var$InteractiveComponent.displayName = 'ElementWithEvents';

});





//# sourceMappingURL=shared.b6e8cd68.js.map
